<template>
  <div>
    <!-- General Information Card -->
    <v-card variant="outlined" class="pa-2">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-information</v-icon>
        General Information
      </v-card-title>
      <v-form ref="officialForm" class="pa-1">
        <v-row class="ma-0">
          <!-- Basic Information -->
          <v-col cols="12" md="6" class="pa-1">
            <v-text-field v-model="officialInfo.code" label="Employee Code" variant="outlined" density="compact"
              hide-details="auto" :rules="[v => !!v || 'Employee code is required']" required disabled></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="6" class="pa-1">
            <v-text-field
              v-model="officialInfo.status"
              label="Status"
              variant="outlined"
              density="compact"
              hide-details="auto"
              readonly
            ></v-text-field>
          </v-col> -->

          <!-- Employee Category & Type -->
          <!-- <v-col cols="12" md="6" class="pa-1">
            <v-select
              v-model="officialInfo.employee_category"
              label="Employee Category"
              variant="outlined"
              density="compact"
              hide-details="auto"
              :items="employeeTypes"
              item-title="text"
              item-value="value"
              :loading="loadingStates.employeeTypes"
              clearable
            ></v-select>
          </v-col> -->
          <v-col cols="12" md="6" class="pa-1">
            <v-select v-model="officialInfo.employee_type_id" :items="employeeTypes" label="Employee Type"
              variant="outlined" density="compact" hide-details="auto" item-title="text" item-value="value"
              :loading="loadingStates.employeeTypes"></v-select>
          </v-col>

          <!-- Department & Section -->
          <v-col cols="12" md="6" class="pa-1">
            <v-select v-model="officialInfo.department_id" label="Department" variant="outlined" density="compact"
              hide-details="auto" :items="departments" item-title="text" item-value="value"
              :loading="loadingStates.departments"></v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-1">
            <v-select v-model="officialInfo.section" label="Section" variant="outlined" density="compact"
              hide-details="auto" :items="sections" item-title="text" item-value="value"
              :loading="loadingStates.sections"></v-select>
          </v-col>

          <!-- Designation & Office Location -->
          <v-col cols="12" md="6" class="pa-1">
            <v-select v-model="officialInfo.designation_id" label="Designation" variant="outlined" density="compact"
              hide-details="auto" :items="designations" item-title="text" item-value="value"
              :loading="loadingStates.designations"></v-select>
          </v-col>

          <v-col cols="12" md="6" class="pa-1">
            <v-select v-model="officialInfo.office_location" label="Office Location" variant="outlined"
              density="compact" hide-details="auto" :items="[
                { text: 'Head Office', value: 'head_office' },
                { text: 'Branch Office', value: 'branch_office' },
                { text: 'Remote', value: 'remote' },
                { text: 'Field Office', value: 'field_office' }
              ]" item-title="text" item-value="value" clearable></v-select>
          </v-col>

          <!-- Important Dates -->
          <v-col cols="12" md="6" class="pa-1">
            <v-date-input
              input-format="dd/mm/yyyy"
              v-model="officialInfo.appointment_date"
              label="Appointment Date"
              prepend-icon=""
              prepend-inner-icon="mdi mdi-calendar-month"
              variant="outlined"
              density="compact"       
              hide-details="auto"
              autocomplete="off"
            ></v-date-input>
          </v-col>
          <v-col cols="12" md="6" class="pa-1">
            <v-date-input
              input-format="dd/mm/yyyy"
              v-model="officialInfo.confirmation_date"
              label="Confirmation Date"
              prepend-icon=""
              prepend-inner-icon="mdi mdi-calendar-month"
              variant="outlined"
              density="compact"
              hide-details="auto"
              autocomplete="off"
            ></v-date-input>
          </v-col>
          <v-col cols="12" md="6" class="pa-1">
            <v-date-input
              input-format="dd/mm/yyyy"
              v-model="officialInfo.joining_date"
              label="Joining Date"
              prepend-icon=""
              prepend-inner-icon="mdi mdi-calendar-month"
              variant="outlined"
              density="compact"
              hide-details="auto"
              autocomplete="off"
            ></v-date-input>
          </v-col>
          <!-- <v-col cols="12" md="6" class="pa-1">
            <v-text-field
              v-model="officialInfo.late_count"
              label="Late Count"
              variant="outlined"
              density="compact"
              hide-details="auto"
              type="number"
              hint="Number of times late"
            ></v-text-field>
          </v-col> -->
          
          <!-- Contact Information -->
          <v-col cols="12" md="6" class="pa-1">
            <v-text-field v-model="officialInfo.phone_office" label="Office Phone" variant="outlined" density="compact"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="pa-1">
            <v-text-field v-model="officialInfo.phone_residence" label="Residence Phone" variant="outlined"
              density="compact" hide-details="auto"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <!-- Bank Information Section -->
    <v-card variant="outlined" class="pa-2 mt-1">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-bank</v-icon>
        Bank Information
      </v-card-title>
      <v-form ref="bankForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" md="6" class="pa-1">
            <v-select v-model="bankInfo.bank_id" label="Bank" variant="outlined" density="compact" hide-details="auto"
              :items="banks" item-title="text" item-value="value" :loading="loadingStates.banks"></v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-1">
            <v-text-field v-model="bankInfo.account_number" label="Bank Account No" variant="outlined" density="compact"
              hide-details="auto" type="text"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <!-- Tax Information Section -->
    <v-card variant="outlined" class="pa-2 mt-1">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-receipt</v-icon>
        Tax Information
      </v-card-title>
      <v-form ref="taxForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field v-model="taxInfo.tin_number" label="TIN No" variant="outlined" density="compact"
              hide-details="auto" type="text"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-select v-model="taxInfo.tax_circle" label="Tax Circle" variant="outlined" density="compact"
              hide-details="auto" :items="[
                { text: 'Dhaka Circle-1', value: 'dhaka_1' },
                { text: 'Dhaka Circle-2', value: 'dhaka_2' },
                { text: 'Chittagong Circle', value: 'chittagong' },
                { text: 'Sylhet Circle', value: 'sylhet' },
                { text: 'Rajshahi Circle', value: 'rajshahi' }
              ]" item-title="text" item-value="value" clearable></v-select>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-select v-model="taxInfo.tax_zone" label="Tax Zone" variant="outlined" density="compact"
              hide-details="auto" :items="[
                { text: 'Zone-1', value: 'zone_1' },
                { text: 'Zone-2', value: 'zone_2' },
                { text: 'Zone-3', value: 'zone_3' },
                { text: 'Zone-4', value: 'zone_4' }
              ]" item-title="text" item-value="value" clearable></v-select>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <!-- Driving Information Section -->
    <v-card variant="outlined" class="pa-2 mt-1">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-car</v-icon>
        Driving Information
      </v-card-title>
      <v-form ref="drivingForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field v-model="drivingInfo.license_number" label="License No" variant="outlined" density="compact"
              hide-details="auto" type="text"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-date-input input-format="dd/mm/yyyy" v-model="drivingInfo.renewal_from" label="Renewal Date From" prepend-icon=""
              prepend-inner-icon="mdi mdi-calendar-month" variant="outlined" density="compact" hide-details="auto"
              autocomplete="off"></v-date-input>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-date-input input-format="dd/mm/yyyy" v-model="drivingInfo.renewal_to" label="Renewal Date To" prepend-icon=""
              prepend-inner-icon="mdi mdi-calendar-month" variant="outlined" density="compact" hide-details="auto"
              autocomplete="off"></v-date-input>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <v-card variant="outlined" class="pa-2 mt-1">
      <v-card-title class="text-subtitle-1 mb-1 pa-2">
        <v-icon class="me-1" size="small">mdi-list-status</v-icon>
        Employment Status
      </v-card-title>
      <v-form ref="drivingForm" class="pa-1">
        <v-row class="ma-0">
          <v-col cols="12" md="6" class="pa-1">
            <v-select 
            v-model="employmentStatus.payment" 
            label="Payment" 
            :items="payment"
            :item-title="(item)=> item.label"
            item-value="value"
            variant="outlined" 
            density="compact"
            hide-details="auto" 
            type="text"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-1">
            <v-select 
            :items="reason"
            :item-title="(item)=> item.reason"
            item-value="id"
            v-model="employmentStatus.reason_id" 
            label="Reason" 
            variant="outlined" 
            density="compact" 
            hide-details="auto"
            autocomplete="off"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" md="6" class="pa-1">
            <v-date-input 
            input-format="dd/mm/yyyy"
            v-model="employmentStatus.leaving_date" 
            label="Leaving Date" 
            prepend-icon=""
            prepend-inner-icon="mdi mdi-calendar-month" 
            variant="outlined" 
            density="compact" 
            hide-details="auto"
            autocomplete="off"
            ></v-date-input>
          </v-col>
          <v-col cols="12" md="6" class="pa-1">
            <v-text-field 
            v-model="employmentStatus.note" 
            label="Leaving Notes" 
            variant="outlined" 
            density="compact" 
            hide-details="auto"
            autocomplete="off"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

// Props
const props = defineProps({
  officialInfo: {
    type: Object,
    required: true
  },
  bankInfo: {
    type: Object,
    required: true
  },
  taxInfo: {
    type: Object,
    required: true
  },
  drivingInfo: {
    type: Object,
    required: true
  },
  reasonInfo: {
    type: Object,
    required: true
  },
  employmentStatus: {
    type: Object,
    required: true
  },
  employeeTypes: {
    type: Array,
    default: () => []
  },
  departments: {
    type: Array,
    default: () => []
  },
  payment: {
    type: Array,
    default: () => []
  },
  sections: {
    type: Array,
    default: () => []
  },
  reason: {
    type: Array,
    default: () => []
  },
  designations: {
    type: Array,
    default: () => []
  },
  banks: {
    type: Array,
    default: () => []
  },
  loadingStates: {
    type: Object,
    default: () => ({})
  }
})

// Emits
const emit = defineEmits([
  'update:officialInfo',
  'update:bankInfo',
  'update:taxInfo',
  'update:drivingInfo',
  'update:reasonInfo'
])

// Local refs
const officialForm = ref(null)
const bankForm = ref(null)
const taxForm = ref(null)
const drivingForm = ref(null)


watch(() => props.officialInfo, (newValue) => {
  console.log('Emitting Official Info:', newValue);
  emit('update:officialInfo', newValue);
}, { deep: true });

watch(() => props.officialInfo, (newValue) => {
  emit('update:officialInfo', newValue)
}, { deep: true })

watch(() => props.bankInfo, (newValue) => {
  emit('update:bankInfo', newValue)
}, { deep: true })

watch(() => props.taxInfo, (newValue) => {
  emit('update:taxInfo', newValue)
}, { deep: true })

watch(() => props.drivingInfo, (newValue) => {
  emit('update:drivingInfo', newValue)
}, { deep: true })

watch(() => props.reasonInfo, (newValue) => {
  emit('update:reasonInfo', newValue)
}, { deep: true })

// Expose form validation methods
defineExpose({
  validateOfficial: () => officialForm.value?.validate(),
  validateBank: () => bankForm.value?.validate(),
  validateTax: () => taxForm.value?.validate(),
  validateDriving: () => drivingForm.value?.validate(),
  validateAll: async () => {
    const results = await Promise.all([
      officialForm.value?.validate(),
      bankForm.value?.validate(),
      taxForm.value?.validate(),
      drivingForm.value?.validate()
    ])
    return results.every(result => result?.valid !== false)
  }
})
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
